import { render, staticRenderFns } from "./applyEdit.vue?vue&type=template&id=8b452c60&scoped=true&"
import script from "./applyEdit.vue?vue&type=script&lang=js&"
export * from "./applyEdit.vue?vue&type=script&lang=js&"
import style0 from "./applyEdit.vue?vue&type=style&index=0&id=8b452c60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b452c60",
  null
  
)

export default component.exports